import styles from './styles.module.css';

const SpecialChar = () => (
  <span>
    Thu
    <span className={styles.specialChar} />c Tốt - Giá Sỉ
  </span>
);
const ThunderTitle = () => (
  <span className={styles.thunderBolt}>
    F<span className={styles.shape} />
    ash Sale
  </span>
);
const MegaDay = ({ monthYear }) => (
  <span>
    <span className={styles.bold}>Mega</span> day {monthYear}
  </span>
);
const DEAL = () => (
  <span>
    <span className={styles.bold}>Ưu đãi mới</span>
  </span>
);

export default { SpecialChar, ThunderTitle, MegaDay, DEAL };
